import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpIcon from '@mui/icons-material/Help';
import ReportIcon from '@mui/icons-material/Report';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

export function FindIcon(iconName) {
  try {
    switch (iconName.toLowerCase().trim()) {
      case 'info':
        return <InfoIcon />;
      case 'help':
        return <HelpIcon />;
      case 'report':
        return <ReportIcon />;
      case 'close':
        return <CloseIcon />;
      case 'error':
        return <ErrorIcon />;
      case 'warning':
        return <WarningIcon />;
      case 'check-circle':
        return <CheckCircleIcon />;
      case 'done-all':
        return <DoneAllIcon />;
      case 'arrow-right':
        return <ArrowRightAltIcon />;
      default:
        return <ReportIcon />;
    }
  } catch (ex) {
    return <ReportIcon />;
  }
}
